import React from "react";
import "./styles.styl";

export default function ToggleSwitch({
  name,
  checked,
  handleCheckBox,
  disabled,
  isLoading,
}) {
  return (
    <div
      className="toggle-switch"
      onClick={!disabled && !isLoading ? handleCheckBox : null}
    >
      <input
        type="checkbox"
        className="toggle-switch-checkbox"
        name={name}
        id={name}
        checked={checked}
        onChange={() => {}}
        disabled={disabled || isLoading}
      />
      <label
        className={`toggle-switch-label${
          isLoading ? " toggle-switch-loading" : ""
        }`}
        htmlFor="toggleSwitch"
      >
        <span
          className={`toggle-switch-inner${
            disabled || isLoading ? " toggle-switch-disabled" : ""
          }`}
        ></span>
        <span className="toggle-switch-switch"></span>
      </label>
    </div>
  );
}
